import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserCreateModalService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   *
   */
  public getRoles(): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .get(`${this.url}/roles`, {responseType: 'json', headers})
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error);
  }
}
